export default __webpack_public_path__ + "static/media/finish.97bce3a3.svg";